import React, { Fragment } from 'react'
import { string, array, number, bool } from 'prop-types'
import withResults from '../hoc/withResults'
import { ARTICLES } from '../utils/constants'
import ResultsContainer from '../components/results/Container'

const ScreensResultsArticles = ({ error, resultsAreLoading, lastQueryUsed, results, totalDocs, ...rest }) => {
  return (
    <Fragment>
      {!error && (
        <ResultsContainer
          aggregationActive={ARTICLES}
          isLoading={resultsAreLoading}
          query={lastQueryUsed}
          lastQueryUsed={lastQueryUsed}
          results={results}
          totalCount={totalDocs}
          {...rest}
        />
      )}
    </Fragment>
  )
}

ScreensResultsArticles.propTypes = {
  results: array,
  totalDocs: number,
  resultsAreLoading: bool,
  lastQueryUsed: string,
  error: bool
}

export default withResults(ScreensResultsArticles, ARTICLES)
